// extracted by mini-css-extract-plugin
export default {"screenLock":"ScreenLock_screenLock__EiWgD","screenLockWrapper":"ScreenLock_screenLockWrapper__kVOEL"};